import { IonIcon } from '@ionic/react';
import { linkOutline } from 'ionicons/icons';
import { PATHS } from '../../navigation/data';
import { LinkTo } from '../atoms/LinkTo';

interface Props {
  index: number;
  data: Record<string, any>;
}

export const CorrelateEntityButton = ({ index, data }: Props) => {
  return (
    <div style={{ position: 'absolute', bottom: 10, right: 34 }}>
      <LinkTo link={`${PATHS.CORRELATE_SALE}/${data?.id}`} data={data} testId={`correlate_${index}`}>
        <IonIcon icon={linkOutline} style={{ fontSize: 18 }} color="dark" />
      </LinkTo>
    </div>
  );
};
